
import {defineComponent} from 'vue'
import CardContentSeparator from "./CardContentSeparator.vue";
import {LightOfferDto, PackSummaryDto} from "../models/InternetAndMobileApiResponse";
import {PromotionType} from "../../common/components/ob1/models/Price";
import Price from "../../common/components/ob1/Price.vue";
import Lien from "../../common/components/ob1/Lien.vue";
import InternetAndMobileCardContent from "./InternetAndMobileCardContent.vue";
import Bouton from "../../common/components/ob1/Bouton.vue";
import ToastSnackBar from "../../common/components/ob1/ToastSnackBar.vue";
import {ToastSnackBarIcon} from "../../common/components/ob1/models/ToastSnackBar";

export default defineComponent({
    name: "InternetAndMobileCard",
    components: {ToastSnackBar, Bouton, InternetAndMobileCardContent, Lien, Price, CardContentSeparator},
    props: {
        banner: {
            type: String,
            required: false,
            default: undefined
        },
        internetOffer: {
            type: Object as () => LightOfferDto,
            required: true
        },
        mobileOffer: {
            type: Object as () => LightOfferDto,
            required: true
        },
        packSummary: {
            type: Object as () => PackSummaryDto,
            required: true
        },
    },
    computed: {
        showPromoDuration(): boolean {
            return this.packSummary.price.promotionType === PromotionType.PROMO_DURATION.toString();
        },
        showPromoDurationFirstMonths(): boolean {
            return this.packSummary.price.promotionType === PromotionType.PROMO_DURATION_FIRST_MONTHS.toString();
        },
        showUntilEndOfPromo(): boolean {
            return this.packSummary.price.promotionType === PromotionType.UNTIL_END_OF_PROMO.toString();
        },
        showEndOfPromotionPrice(): boolean {
            return this.packSummary.price.promotionType === PromotionType.END_OF_PROMO.toString();
        },
        showChildrenPromotionPrice(): boolean {
            return this.packSummary.price.promotionType === PromotionType.CHILDREN_PROMOTION.toString();
        },
        summaryButtonIsButton(): boolean {
            return !this.packSummary.buttonCta.href || Object.keys(this.packSummary.formParams).length > 0;
        },
        summaryButtonHref(): string {
            return this.summaryButtonIsButton ? '' : this.packSummary.buttonCta.href;
        },
        summaryButtonDataTimer(): number {
            return this.summaryButtonIsButton ? 10 : 0;
        },
        token() {
            return document.querySelector('[data-token]').getAttribute('data-token')
        }
    },
    methods: {
        showErrorMessage() {
            this.$refs.internetAndMobileToastSnackBar.showToastSnackBarMessage(
                {
                    icon: ToastSnackBarIcon.ICON_ERROR_SEVERE,
                    message: 'Une erreur est survenue. Veuillez réessayer plus tard.',
                }
            );
        },
        handleButtonClick() {
            if (this.summaryButtonIsButton) {
                this.$refs.redirectButton.startAnimation();

                const params = this.packSummary.formParams;
                const url = this.packSummary.buttonCta.href;
                // Envoi de la requête POST
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'token': this.token
                    },
                    body: JSON.stringify(params)
                })
                    .then(response => {
                        if (!response.ok) {
                            this.showErrorMessage();
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.$refs.redirectButton.stopAnimation();
                        if (data?.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        } else {
                            this.showErrorMessage();
                        }
                    })
                    .catch(error => {
                        this.$refs.redirectButton.stopAnimation();
                        if (error?.redirectUrl) {
                            window.location.href = error.redirectUrl;
                        } else {
                            this.showErrorMessage();
                        }
                    });
            }
        },
    }
})
